/**
 * Avatar — an initials chip derived from a name. Deterministic colour from a
 * small WSS-toned palette unless an explicit colour is supplied.
 */

import { cx } from './cx';

interface AvatarProps {
  name: string;
  /** Pixel size of the (square) avatar. */
  size?: number;
  /** Explicit background colour; otherwise derived from the name. */
  color?: string;
  className?: string;
}

const PALETTE = ['#000080', '#F07D00', '#0d3b75', '#5B6577', '#1f6f5c', '#7b3f9a'];

export default function Avatar({ name, size = 32, color, className = '' }: AvatarProps) {
  const initials =
    name
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((s) => s[0] ?? '')
      .join('')
      .toUpperCase() || '?';
  const bg = color ?? PALETTE[(name.charCodeAt(0) || 0) % PALETTE.length];
  return (
    <div
      style={{ width: size, height: size, background: bg, fontSize: size * 0.38 }}
      className={cx(
        'rounded-full text-white font-semibold flex items-center justify-center shrink-0',
        className,
      )}
    >
      {initials}
    </div>
  );
}
